import { useSyncExternalStore } from "react";

let isOpen = false;
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((l) => l());
}

export function openFeedbackDialog() {
  isOpen = true;
  emit();
}

export function closeFeedbackDialog() {
  isOpen = false;
  emit();
}

function subscribe(cb: () => void) {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}

function getSnapshot() {
  return isOpen;
}

export function useFeedbackDialogOpen() {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
